// Created by hejikun on 2017/10/25 0025.
let state = {
  doc_detail: {}, // 医生的详细信息
  overtime_schedule: {}, // 预约的时间
  overtime_upload_imgs: [], // 上传图片
  overtime_form_data: {}, // 问诊订单数据
  overtime_order_info: {}, // 问诊支付信息
  overtime_order_list: [],
  overtime_doc_note: ''
}

const actions = {
  // 获取医生详细信息
  getDocDetail({ commit }, args) {
    console.log('args', args)
    window.newDytApiBaseApi
      .get(`plus-registration/pat/api/v1/doctor/${args.doctorUserId}`)
      .then((res) => {
        // console.log('vuex_res', res.data)
        commit('set_doc_detail', res.data)
        return Promise.resolve(res.data)
      })
      .catch((e) => {
        return Promise.reject(e)
      })
  },
  // 加载订单列表
  getOrderList({ commit }, args) {
    console.log('加载订单的参数', args)
    window.newDytApiBaseApi
      .get(`plus-registration/pat/api/v1/order/page?page=${args.page}&pageSize=${args.pageSize}`)
      .then((res) => {
        commit({
          type: 'setList',
          dataType: 'overtime_order_list',
          module: 'overtimeClinic',
          page: args.page,
          data: res.data.content
        })
        return Promise.resolve(res.data.content)
      })
      .catch((e) => {
        return Promise.reject(e)
      })
  }
  // // 获取部门列表
  // getDeps ({commit}) {
  //   window.axiosBaseApi.get('/ask2/sdepart').then(res => {
  //     if (res.data.code === 1) {
  //       commit('set_ask_deps', res.data.data)
  //       return Promise.resolve(res.data.data)
  //     } else {
  //       commit('set_ask_deps', [])
  //       return Promise.resolve([])
  //     }
  //   }).catch(e => {
  //     return Promise.reject(e)
  //   })
  // }
}

const getters = {}

const mutations = {
  // 设置医生详情
  set_doc_detail(state, arg) {
    state.doc_detail = arg
  },
  set_overtime_schedule(state, arg) {
    console.log('vuex_schedule', arg)
    state.overtime_schedule = arg
  },
  // 设置上传图片
  set_overtime_upload_imgs(state, arg) {
    state.overtime_upload_imgs = arg
  },
  set_overtime_form_data(state, arg) {
    state.overtime_form_data = arg
  },
  set_overtime_order_info(state, arg) {
    state.overtime_order_info = arg
  },
  set_overtime_doc_note(state, arg) {
    state.overtime_doc_note = arg
  }
  // 设置
  // // 设置部门列表
  // set_ask_deps (state, arg) {
  //   state.ask_deps = arg
  // },
  // // 设置上传图片
  // set_ask_upload_imgs (state, arg) {
  //   state.ask_upload_imgs = arg
  // },
  // set_ask_form_data (state, arg) {
  //   state.ask_form_data = arg
  // },
  // set_ask_order_info (state, arg) {
  //   state.ask_order_info = arg
  // },
  // set_ask_tel_form (state, args) {
  //   switch (args.type) {
  //     case 'phone':
  //       state.ask_tel_form.phone = args.data
  //       break
  //     case 'time':
  //       state.ask_tel_form.time = args.data
  //       break
  //     case 'price':
  //       state.ask_tel_form.price = args.data
  //       break
  //     default:
  //       break
  //   }
  // }
}

export default {
  state,
  mutations,
  actions,
  getters
}
